import React from 'react';
import appAccessLevels from '@lib/constants/appAccessLevels';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, changeAppPermissions } from '@redux/ducks/userPermissions/userPermissions';

const ChangeAppAccessComponent = ({ appRoles, app, changeAppPermissions }) => {
  const isRoleActiveOrOff = role => app.access?.role === role.key || (!app.access && role.key === 'off');

  return (
    <div className="content panel-content">
      <div className="form-row form-row-tight">
        <label>{t('label.access')}</label>
        <div className="role-tags">
          {appRoles.map((role: any) => (
            <a
              key={role.key}
              onClick={() => changeAppPermissions(role.key)}
              className={`role-btn role-${role.key} ${isRoleActiveOrOff(role) ? 'active' : ''}`}
            >
              {t(role.name)}
            </a>
          ))}
        </div>
      </div>
      <div className="role-desc">
        {appRoles.map((role: any) => (isRoleActiveOrOff(role) ? <p key={role.key}>{t(role.description)}</p> : null))}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentApp } = getUserPermissionsState(state);
  return { app: currentApp, appRoles: appAccessLevels };
};

const mapStateToDispatch = {
  changeAppPermissions,
};

export const ChangeAppAccess = connectWithStore(mapStateToProps, mapStateToDispatch)(ChangeAppAccessComponent);
